import {
  CloudAccountApiChangeDiscoverInventoryIntervalRequest,
  CloudAccountApiGetCloudAccountsRequest,
  PageCloudAccountGetResponse,
} from '@ariksa/cloud-account/api';
import {
  AvailableSLAResponse,
  GetSlasResponse,
  SlaApiAddAvailableSlaOptionsRequest,
  SlaApiDeleteAvailableSlaOptionsRequest,
  SlaApiUpdateSlaRequest,
  UpdateSlaResponse,
} from '@ariksa/notification/api';
import { QueryAction } from 'services/types';
import { PagedQueryState } from 'services/utils/PagedQueryState';
import { QueryState } from 'services/utils/QueryState';

import { createSlice } from 'utils/@reduxjs/toolkit';

import { ContainerState } from './types';

// The initial state of the Settings container
export const initialState: ContainerState = {
  updateAccountDiscoveryInterval: QueryState.init({}),
  accounts: PagedQueryState.init([]),
  SLAs: QueryState.init([]),
  updateSLAs: QueryState.init({} as UpdateSlaResponse),
  availableSLAs: QueryState.init([]),
  updatePredefinedSlas: QueryState.init({}),
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    //severity based
    getSLAs(state, action: QueryAction<GetSlasResponse[]>) {
      state.SLAs = QueryState.next(state.SLAs, action);
    },
    updateSLAs(
      state,
      action: QueryAction<UpdateSlaResponse, SlaApiUpdateSlaRequest>,
    ) {
      state.updateSLAs = QueryState.next(state.updateSLAs, action);
    },

    //all available sla options
    getAvailableSLAOptions(
      state,
      action: QueryAction<AvailableSLAResponse[], any>,
    ) {
      state.availableSLAs = QueryState.next(state.availableSLAs, action);
    },
    updateAvailableSlaOption(
      state,
      action: QueryAction<any, SlaApiAddAvailableSlaOptionsRequest>,
    ) {
      state.updatePredefinedSlas = QueryState.next(
        state.updatePredefinedSlas,
        action,
      );
    },
    deleteAvailableSlaOption(
      state,
      action: QueryAction<any, SlaApiDeleteAvailableSlaOptionsRequest>,
    ) {
      state.updatePredefinedSlas = QueryState.next(
        state.updatePredefinedSlas,
        action,
      );
    },

    updateAccountDiscoveryInterval(
      state,
      action: QueryAction<
        any,
        CloudAccountApiChangeDiscoverInventoryIntervalRequest
      >,
    ) {
      state.updateAccountDiscoveryInterval = QueryState.next(
        state.updateAccountDiscoveryInterval,
        action,
      );
    },
    getCloudAccounts(
      state,
      action: QueryAction<
        PageCloudAccountGetResponse,
        CloudAccountApiGetCloudAccountsRequest
      >,
    ) {
      state.accounts = PagedQueryState.next(state.accounts, action, {
        mapTotalCount: r => r.total || 0,
        mapData: r => r.items,
      });
    },
  },
});

export const { actions, reducer, name: sliceKey } = settingsSlice;
